var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleCheckEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3.85a8.15 8.15 0 1 0 0 16.3 8.15 8.15 0 0 0 0-16.3M2.15 12c0-5.44 4.41-9.85 9.85-9.85s9.85 4.41 9.85 9.85-4.41 9.85-9.85 9.85S2.15 17.44 2.15 12m13.451-2.601a.85.85 0 0 1 0 1.202l-4 4a.85.85 0 0 1-1.202 0l-2-2a.85.85 0 1 1 1.202-1.202L11 12.798l3.399-3.399a.85.85 0 0 1 1.202 0",
  clipRule: "evenodd"
})));
export default SvgCircleCheckEmpty;